import axios from '@/config/axios';

const model={
    getCode(params){
        return axios({
            url:'business/user/sendcode',
            method:'post',
            data:params,
            msg:true
        })
    },
    login(params){
        return axios({
            url:'business/user/login',
            method:'post',
            data:params,
            msg:true
        })
    },
    loginOut(){
        return axios({
            url:`business/user/loginOut/${sessionStorage['access_token']}`,
            msg:true
        })
    },
    updatePwd(data) {
        return axios({
            url: '/business/user/resetkey',
            method: 'POST',
            data,
            msg: true
        })
    }
}

export default model


// WEBPACK FOOTER //
// ./src/models/login.js